module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wwf-petition-progress-container"
  }, [_c('div', {
    attrs: {
      "id": "wwf-petition-bar"
    }
  }, [_c('div', {
    attrs: {
      "id": "wwf-petition-progress"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 600 160"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "myClip"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": (_vm.revdirection) ? '100%' : '0%',
      "height": "100%"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "width",
      "from": (_vm.revdirection) ? '100%' : '0%',
      "to": (_vm.revdirection) ? (100 - _vm.percentage) + '%' : _vm.percentage + '%',
      "dur": "3.5s",
      "fill": "freeze"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "straw",
      "d": "M2,125.9h433.1v31.2H2V125.9z M490.4,136.5l107-111.3l-21.3-22L468.4,114.5L490.4,136.5z M460.6,121.6\n        l17.7,26.2l5-3.5l-18.4-26.2L460.6,121.6z M451.4,125.9l10.6,29.8l5-2.1l-10.6-29.8L451.4,125.9z M441.5,125.9h5.7v31.9h-5.7V125.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "strawColoured",
      "d": "M2,125.9h433.1v31.2H2V125.9z M490.4,136.5l107-111.3l-21.3-22L468.4,114.5L490.4,136.5z M460.6,121.6\n        l17.7,26.2l5-3.5l-18.4-26.2L460.6,121.6z M451.4,125.9l10.6,29.8l5-2.1l-10.6-29.8L451.4,125.9z M441.5,125.9h5.7v31.9h-5.7V125.9z",
      "fill": "#00728f"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "clip-path": "url(#myClip)",
      "xlink:href": "#straw",
      "fill": "#00ACCD"
    }
  })])]), _vm._v(" "), _c('div')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48293ce1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/Progressbar.vue
// module id = 756
// module chunks = 0